import React, { FC } from 'react';
import guarantee from './img/guarantee.png';
import * as S from './styled';

export const MoneyBack: FC = () => {
	return (
		<S.Container>
			<S.Title>100% Money-Back Guarantee</S.Title>
			<S.Content>
				We are confident in the quality of our plan and believe it might work for you. We are even
				ready to return money back if you don’t see visible results within 30 days and may confirm
				that you followed our program for at least 7 days in a row.
			</S.Content>
			<S.Content>We try to make your life healthier and more joyful!</S.Content>

			<S.Image src={guarantee} alt='guarantee' />
		</S.Container>
	);
};
